import { getData, delData } from '../http'

export default {
	data() {
		return {
			loading: false,
			dataList: undefined,
			dataMeta: {},
			query: {
				page: 1
      },
      config: {
        getUrl: '',
        delUrl: ''
      }
		}
	},
	methods: {
		getTableData(callback) {
			this.loading = true
			for (let key in this.query) {
				if (this.query[key] === '') {
					this.query[key] = undefined
				}
			}
			getData(this.config.getUrl, this.query)
				.then(res => {
          this.dataList = res.data
          this.dataMeta = res
					if (callback && typeof callback === 'function') {
						callback()
					}
				})
				.finally(() => {
					this.loading = false
				})
		},
		handleSearch() {
			this.query.page = 1
			this.getTableData()
    },
    handlePageChange(page) {
      this.query.page = page
      this.getTableData()
    },
    handleDelete(id) {
			this.$confirm('确定要删除吗？', {
				type: 'warning'
			}).then(res => {
				delData(this.config.delUrl + '/' + id).then(() => {
					this.$message.success('删除成功')
					this.getTableData()
				})
			})
    }
  },
  created() {
    this.getTableData()
  }
}
